import { Component, OnInit,  Renderer2, ElementRef  } from '@angular/core';
import { HttpEventType, HttpResponse, HttpClient, HttpHeaders, HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { SignatureModalComponent } from '../signature-modal/signature-modal.component';
import {NgbModal, ModalDismissReasons, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../environments/environment';
// import { map } from 'rxjs/operators';
import { FileDownloadService}  from '../../services/file-download.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { MifielSignatureService } from 'src/app/services/mifiel-signature.service';
import { ErrorHandlerService } from '../../services/error-handler.service';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css']
})
export class FileUploadComponent implements OnInit {
  selectedFiles?: FileList;
  currentFile?: File;
  progress = 0;
  message = '';
  pdfContent: Uint8Array = new Uint8Array(0);
  validPdf: boolean = false;
  actualFileSize?: number = 0;
  convertedActualFileSize?: string = '';
  credits: number;
  fileInfos?: Observable<any>;
  private scriptParentNode?: Node;
  private baseUrl = environment.url3;
  // private scriptParentNode?: Node; // Change: Make it optional
  // private scriptParentNode: unknown; // Change: Use 'unknown' type

  constructor(private uploadService: FileUploadService, 
    private modalService: NgbModal, 
    private http: HttpClient,
    private fileDownloadService: FileDownloadService,   
    private toastr: ToastrService,
    private router: Router,
    private errorHandler: ErrorHandlerService,
    private miFielSignatureService: MifielSignatureService
    ) { }

  ngOnInit(): void {
    this.credits = this.miFielSignatureService.getMaxMonthSignatures();
    this.loadCount(localStorage.getItem('userTaxId'));
    this.fileInfos = this.uploadService.getUserFiles();

  }

  // ngOnDestroy(): void {
  //   // Clean up the script element when the component is destroyed
  //   if (this.scriptParentNode) {
  //     const existingScript = document.getElementById('mifiel-js');
  //     if (existingScript) {
  //       this.renderer.removeChild(this.scriptParentNode, existingScript);
  //     }
  //   }
  // }

  selectFile(event: any): void {
    this.selectedFiles = event.target.files;
    this.actualFileSize = this.selectedFiles.item(0).size;
    this.validPdf = false;
  
    if (this.selectedFiles && this.actualFileSize !== undefined) {
      const maxSizeInBytes = 20 * 1024 * 1024; // 20 MB in bytes
  
      if (this.actualFileSize <= maxSizeInBytes) {
        this.validPdf = true;
        const file = this.selectedFiles[0]; // Use the first file in the list
        // const file = event.target.files[0]; // Another way to get the first file
  
        this.loadPdfContent(file).then((pdfContent) => {
          this.pdfContent = pdfContent;
        }).catch((error) => {
          console.error('Error loading PDF content:', error);
        });
  
        console.info("File size ok" + this.formatFileSize(this.actualFileSize));
        this.convertedActualFileSize = this.formatFileSize(this.actualFileSize);
      } else {
        console.error('File size exceeds the allowed limit (20 MB).');
        this.pdfContent = new Uint8Array(0);
      }
    }

  }

  formatFileSize(sizeInBytes: number): string {
    const KB = 1024;
    const MB = KB * 1024;
    const GB = MB * 1024;
  
    if (sizeInBytes < KB) {
      return sizeInBytes + ' B';
    } else if (sizeInBytes < MB) {
      return (sizeInBytes / KB).toFixed(2) + ' KB';
    } else if (sizeInBytes < GB) {
      return (sizeInBytes / MB).toFixed(2) + ' MB';
    } else {
      return (sizeInBytes / GB).toFixed(2) + ' GB';
    }
  }

  loadPdfContent(file: File): Promise<Uint8Array> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        // const arrayBuffer = event.target?.result as ArrayBuffer;
        // const arrayBuffer = event.target.result as ArrayBuffer;
        const arrayBuffer = event.target.result as ArrayBuffer;
        if (arrayBuffer) {
          const uint8Array = new Uint8Array(arrayBuffer);
          resolve(uint8Array);
        } else {
          reject(new Error('Failed to read file content.'));
        }
      };
  
      // Pass the File object directly to readAsArrayBuffer
      reader.readAsArrayBuffer(file);
    });
  }

  upload(): void {
    this.progress = 0;

    if (this.selectedFiles) {
      const file: File | null = this.selectedFiles.item(0);

      if (file) {
        this.currentFile = file;

        this.uploadService.upload(this.currentFile).subscribe(
          (event: any) => {
            if (event.type === HttpEventType.UploadProgress) {
              this.progress = Math.round(100 * event.loaded / event.total);
            } else if (event instanceof HttpResponse) {
              this.message = event.body.message;
              this.toastr.info('Archivo Cargado Correctamente!', '(Persona Fisica)');
              // this.fileInfos = this.uploadService.getFiles();
              this.fileInfos = this.uploadService.getUserFiles();
              this.validPdf = false;
              this.router.navigate(['administracion/mydocuments2']);
            }
          },
          (err: any) => {
            console.log(err);
            this.progress = 0;

            if (err.error && err.error.message) {
              this.message = err.error.message;
            } else {
              this.message = 'Could not upload the file!';
            }

            this.currentFile = undefined;
          });

      }

      this.selectedFiles = undefined;
      this.progress = 0;
    }
  }
  
  downloadFile(fileId: string, fileName: string) {
    this.fileDownloadService.getFile(fileId).subscribe(blob => {
      // Create a link element to download the blob
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName; // Optionally, you can set a specific filename here
      link.click();

      // Clean up by revoking the URL object
      window.URL.revokeObjectURL(url);
    });
  }

  // Method to handle file deletion
  deleteFile(fileId: string) {
    this.fileDownloadService.deleteFile(fileId).subscribe({
      next: () => {
        this.toastr.success('Archivo Eliminado Correctamente!', '(Persona Fisica)');
        console.log('File successfully deleted');
        this.fileInfos = this.uploadService.getUserFiles();
        // this.router.navigate(['administracion/mydocuments2']);
        // this.reloadCurrentRoute(); 
        // Handle additional logic after successful deletion, e.g., updating the UI
      },
      error: (error) => {
        console.error('There was an error!', error);
        this.errorHandler.checkForError(error,'file-upload -> deleteFile');
        // Handle errors here, possibly show user feedback
      }
    });
  }

  loadCount(userTaxId: string): void {
    // Example of using an HTTP service that might fail
    
    this.miFielSignatureService.getCountByUserTaxId(userTaxId).subscribe({
      next: (data) => {
        console.log('Server Says...');
        console.log(data['thisMonthSignatures'])
      },
      error: (error) => {
        this.errorHandler.checkForError(error,'file-upload -> loadCount');
      }
    });
  }

}
